export const REQUEST_TEST = 'REQUEST_TEST';
export const RECEIVED_TEST = 'RECEIVED_TEST';
export const ERROR_TEST = 'ERROR_TEST';
export const CHECKED_QUESTION = 'CHECKED_QUESTION';
export const MARKED_QUESTION = 'MARKED_QUESTION';
export const TOUCHED_QUESTION = 'TOUCHED_QUESTION';
export const TEST_TIME_START = 'TEST_TIME_START';
export const TEST_TIME_END = 'TEST_TIME_END';
export const CLEAR_TEST = 'CLEAR_TEST';
export const SELECTED_ANSWERS = 'SELECTED_ANSWERS';
export const QUESTIONS_INFO = 'QUESTIONS_INFO';
export const CHANGE_QUESTION = 'CHANGE_QUESTION';
export const GOTO_QUESTION = 'GOTO_QUESTION';

//regitstation
export const REQUEST_REGISTATION = 'REQUEST_REGISTATION';
export const REGISTATION_STATUS = 'REGISTATION_STATUS';
export const ERROR_REGISTATION = 'ERROR_REGISTATION';
export const CLEAR_REGISTATION_INFO = 'CLEAR_REGISTATION_INFO';

//regitstration verify
export const REQUEST_REGISTRATION_VERIFY = 'REQUEST_REGISTRATION_VERIFY';
export const REGISTRATION_VERIFY_STATUS = 'REGISTRATION_VERIFY_STATUS';
export const ERROR_REGISTRATION_VERIFY = 'ERROR_REGISTRATION_VERIFY';
export const CLEAR_REGISTRATION_VERIFY_INFO = 'CLEAR_REGISTRATION_VERIFY_INFO';

//login
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_RESPONCE = 'LOGIN_RESPONCE';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const CLEAR_LOGIN_INFO = 'CLEAR_LOGIN_INFO';

//otp verify
export const REQUEST_OTP_VERIFY = 'REQUEST_OTP_VERIFY';
export const RECEIVED_OTP_VERIFY = 'RECEIVED_OTP_VERIFY';
export const ERROR_OTP = 'ERROR_OTP';
export const CLEAR_OTP_INFO = 'CLEAR_OTP_INFO';

//create test
export const REQUEST_CREATE_TEST = 'REQUEST_CREATE_TEST';
export const RECEIVED_CREATE_TEST = 'RECEIVED_CREATE_TEST';
export const ERROR_CREATE_TEST = 'ERROR_CREATE_TEST';
export const CLEAR_CREATE_TEST = 'CLEAR_CREATE_TEST';

//test type
export const GET_TEST_TYPE = 'GET_TEST_TYPE';
export const SET_TEST_TYPE = 'SET_TEST_TYPE';
export const CLEAR_TEST_TYPE = 'CLEAR_TEST_TYPE';
export const PRACTICE_TEST = 'practice';
export const CHALLENGE_TEST = 'challenge';
export const DAILY_TEST = "daily_test";
export const PLANNED_TEST = 'planned';
export const ADMIN_TEST = 'admin';
export const TEST_SERIES = 'TEST_SERIES';

//get exams
export const REQUEST_EXAMS = 'REQUEST_EXAMS';
export const RECEIVED_EXAMS = 'RECEIVED_EXAMS';
export const CLEAR_EXAMS = 'CLEAR_EXAMS';
export const ERROR_EXAMS = 'ERROR_EXAMS';

//send exam preferences
export const SEND_EXAM_PREFERENCES = 'SEND_EXAM_PREFERENCES';
export const SUCCESS_EXAM_PREFERENCES = 'SUCCESS_EXAM_PREFERENCES';
export const ERROR_EXAM_PREFERENCES = 'ERROR_EXAM_PREFERENCES';
// export const CLEAR_EXAM_PREFERENCES = 'CLEAR_EXAM_PREFERENCES';

//axios error 
export const AXIOS_ERROR = 'AXIOS_ERROR';

//home info
export const REQUEST_HOME_INFO = 'REQUEST_HOME_INFO';
export const RECEIVED_HOME_INFO = 'RECEIVED_HOME_INFO';
export const CLEAR_HOME_INFO = 'CLEAR_HOME_INFO';
export const ERROR_HOME_INFO = 'ERROR_HOME_INFO';

//current affairs 
export const REQUEST_CURRENT_AFFAIRS = 'REQUEST_CURRENT_AFFAIRS';
export const RECEIVED_CURRENT_AFFAIRS = 'RECEIVED_CURRENT_AFFAIRS';
export const CLEAR_CURRENT_AFFAIRS = 'CLEAR_CURRENT_AFFAIRS';
export const ERROR_CURRENT_AFFAIRS = 'ERROR_CURRENT_AFFAIRS';
// current affairs full content description
export const REQUEST_FULL_CONTENT_DESCRIPTION = 'REQUEST_FULL_CONTENT_DESCRIPTION';
export const RECEIVED_FULL_CONTENT_DESCRIPTION = 'RESPONSE_FULL_CONTENT_DESCRIPTION';
export const CLEAR_FULL_CONTENT_DESCRIPTION = 'CLEAR_FULL_CONTENT_DESCRIPTION';
export const ERROR_FULL_CONTENT_DESCRIPTION = 'ERROR_FULL_CONTENT_DESCRIPTION';


//logout 
export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const RECEIVED_LOGOUT = 'RECEIVED_LOGOUT';
export const ERROR_LOGOUT = 'ERROR_LOGOUT';
export const CLEAR_LOGOUT_ALL_DATA = 'CLEAR_LOGOUT_ALL_DATA';


//get subject
export const REQUEST_SUBJECTS = 'REQUEST_SUBJECTS';
export const RECEIVED_SUBJECTS = 'RECEIVED_SUBJECTS';
export const ERROR_SUBJECTS = 'ERROR_SUBJECTS';
export const CLEAR_SUBJECTS = 'CLEAR_SUBJECTS';

//selected exam
export const USER_SELECTED_EXAM = 'USER_SELECTED_EXAM';
export const CLEAR_USER_SELECTED_EXAM = 'CLEAR_USER_SELECTED_EXAM';

//attempt test
export const REQUEST_ATTEMPT_TEST = 'REQUEST_ATTEMPT_TEST';
export const RECEIVED_ATTEMPT_TEST = 'RECEIVED_ATTEMPT_TEST';
export const CLEAR_ATTEMPT_TEST = 'CLEAR_ATTEMPT_TEST';
export const ERROR_ATTEMPT_TEST = 'ERROR_ATTEMPT_TEST';

//start test
export const REQUEST_START_TEST = 'REQUEST_START_TEST';
export const RECEIVED_START_TEST = 'RECEIVED_START_TEST';
export const CLEAR_START_TEST = 'CLEAR_START_TEST';
export const ERROR_START_TEST = 'ERROR_START_TEST';

//update profile
export const REQUEST_UPDATE_PROFILE = 'REQUEST_UPDATE_PROFILE';
export const RECEIVED_UPDATE_PROFILE = 'RECEIVED_UPDATE_PROFILE';
export const CLEAR_UPDATE_PROFILE = 'CLEAR_UPDATE_PROFILE';
export const ERROR_UPDATE_PROFILE = 'ERROR_UPDATE_PROFILE';
//submit test
export const REQUEST_SUBMIT_TEST = 'REQUEST_SUBMIT_TEST';
export const RECEIVED_SUBMIT_TEST = 'RECEIVED_SUBMIT_TEST';
export const CLEAR_SUBMIT_TEST = 'CLEAR_SUBMIT_TEST';
export const ERROR_SUBMIT_TEST = 'ERROR_SUBMIT_TEST';

//change phone number
export const REQUEST_CHANGE_PHONE_NUMBER = 'REQUEST_CHANGE_PHONE_NUMBER';
export const RECEIVED_CHANGE_PHONE_NUMBER = 'RECEIVED_CHANGE_PHONE_NUMBER';
export const CLEAR_CHANGE_PHONE_NUMBER = 'CLEAR_CHANGE_PHONE_NUMBER';
export const ERROR_CHANGE_PHONE_NUMBER = 'ERROR_CHANGE_PHONE_NUMBER';

//verify change number
export const REQUEST_VERIFY_CHANGE_PHONE_NUMBER = 'REQUEST_VERIFY_CHANGE_PHONE_NUMBER';
export const RECEIVED_VERIFY_CHANGE_PHONE_NUMBER = 'RECEIVED_VERIFY_CHANGE_PHONE_NUMBER';
export const CLEAR_VERIFY_CHANGE_PHONE_NUMBER = 'CLEAR_VERIFY_CHANGE_PHONE_NUMBER';
export const ERROR_VERIFY_CHANGE_PHONE_NUMBER = 'ERROR_VERIFY_CHANGE_PHONE_NUMBER';

//verify mail id
export const REQUEST_VERIFY_EMAIL = 'REQUEST_VERIFY_EMAIL';
export const RECEIVED_VERIFY_EMAIL = 'RECEIVED_VERIFY_EMAIL';
export const CLEAR_VERIFY_EMAIL = 'CLEAR_VERIFY_EMAIL';
export const ERROR_VERIFY_EMAIL = 'ERROR_VERIFY_EMAIL';

//subscribe
export const REQUEST_SUBSCRIBE = 'REQUEST_SUBSCRIBE';
export const RECEIVED_SUBSCRIBE = 'RECEIVED_SUBSCRIBE';
export const CLEAR_SUBSCRIBE = 'CLEAR_SUBSCRIBE';
export const ERROR_SUBSCRIBE = 'ERROR_SUBSCRIBE';

// test analysis 
export const REQUEST_TEST_ANALYSIS = 'REQUEST_TEST_ANALYSIS';
export const RECEIVED_TEST_ANALYSIS = 'RECEIVED_TEST_ANALYSIS';
export const CLEAR_TEST_ANALYSIS = 'CLEAR_TEST_ANALYSIS';
export const ERROR_TEST_ANALYSIS = 'ERROR_TEST_ANALYSIS';

//get planner info
export const REQUEST_PLANNER_INFO = 'REQUEST_PLANNER_INFO';
export const RECEIVED_PLANNER_INFO = 'RECEIVED_PLANNER_INFO';
export const CLEAR_PLANNER_INFO = 'CLEAR_PLANNER_INFO';
export const ERROR_PLANNER_INFO = 'ERROR_PLANNER_INFO';

//update planner info
export const REQUEST_ADD_PLANNER_INFO = 'REQUEST_ADD_PLANNER_INFO';
export const RECEIVED_ADD_PLANNER_INFO = 'RECEIVED_ADD_PLANNER_INFO';
export const CLEAR_ADD_PLANNER_INFO = 'CLEAR_ADD_PLANNER_INFO';
export const ERROR_ADD_PLANNER_INFO = 'ERROR_TEST_ADD_PLANNER_INFO';

//payment request
export const REQUEST_PAYMENT_FOR_CREATE_TEST = 'REQUEST_PAYMENT_FOR_CREATE_TEST';
export const SUCCESS_PAYMENT_FOR_CREATE_TEST = 'SUCCESS_PAYMENT_FOR_CREATE_TEST';
export const FAILURE_PAYMENT_FOR_CREATE_TEST = 'FAILURE_PAYMENT_FOR_CREATE_TEST';
export const CLEAR_PAYMENT_FOR_CREATE_TEST = 'CLEAR_PAYMENT_FOR_CREATE_TEST';


// upi payment request 
export const REQUEST_ADD_USER_ACCOUNT_INFO = "REQUEST_ADD_USER_ACCOUNT_INFO";
export const SUCCESS_ADD_USER_ACCOUNT_INFO = "SUCCESS_ADD_USER_ACCOUNT_INFO";
export const FAILURE_ADD_USER_ACCOUNT_INFO = "FAILURE_ADD_USER_ACCOUNT_INFO";
export const CLEAR_ADD_USER_ACCOUNT_INFO = "CLEAR_ADD_USER_ACCOUNT_INFO";

// Ads Screen 
export const REQUEST_ADS_INFO = "REQUEST_ADS_INFO";
export const RECEIVED_ADS_INFO = "RECEIVED_ADS_INFO";
export const CLEAR_ADS_INFO = "CLEAR_ADS_INFO";
export const ERROR_ADS_INFO = "ERROR_ADS_INFO";

//practice test
export const REQUEST_CREATE_PRACTICE_TEST = 'REQUEST_CREATE_PRACTICE_TEST';
export const RECEIVED_CREATE_PRACTICE_TEST = 'RECEIVED_CREATE_PRACTICE_TEST';
export const CLEAR_CREATE_PRACTICE_TEST = 'CLEAR_CREATE_PRACTICE_TEST';
export const ERROR_CREATE_PRACTICE_TEST = 'ERROR_CREATE_PRACTICE_TEST';

//test invite response
export const REQUEST_TEST_INVITE_RESPONSE = "REQUEST_TEST_INVITE_RESPONSE";
export const RECEIVED_TEST_INVITE_RESPONSE = "RECEIVED_TEST_INVITE_RESPONSE";
export const CLEAR_TEST_INVITE_RESPONSE = "CLEAR_TEST_INVITE_RESPONSE";
export const ERROR_TEST_INVITE_RESPONSE = "ERROR_TEST_INVITE_RESPONSE";


//get single test info
export const REQUEST_SINGLE_TEST_INFO = "REQUEST_SINGLE_TEST_INFO";
export const RECEIVED_SINGLE_TEST_INFO = "RECEIVED_SINGLE_TEST_INFO";
export const CLEAR_SINGLE_TEST_INFO = "CLEAR_SINGLE_TEST_INFO";
export const ERROR_SINGLE_TEST_INFO = "ERROR_SINGLE_TEST_INFO";


//add test
export const REQUEST_ADD_TEST = "REQUEST_ADD_TEST";
export const RECEIVED_ADD_TEST = "RECEIVED_ADD_TEST";
export const CLEAR_ADD_TEST = "CLEAR_ADD_TEST";
export const ERROR_ADD_TEST = "ERROR_ADD_TEST";

// performance graph
export const REQUEST_SUBJECT_PERFORMANCE_INFO = "REQUEST_SUBJECT_PERFORMANCE_INFO";
export const RECEIVED_SUBJECT_PERFORMANCE_INFO = "RECEIVED_SUBJECT_PERFORMANCE_INFO";
export const CLEAR_SUBJECT_PERFORMANCE_INFO = "CLEAR_SUBJECT_PERFORMANCE_INFO";
export const ERROR_SUBJECT_PERFORMANCE_INFO = "ERROR_SUBJECT_PERFORMANCE_INFO";

// library books
export const REQUEST_LIBRARY_BOOKS = "REQUEST_LIBRARY_BOOKS ";
export const RECEIVED_LIBRARY_BOOKS = "RECEIVED_LIBRARY_BOOKS ";
export const ERROR_LIBRARY_BOOKS = "ERROR_LIBRARY_BOOKS";
export const CLEAR_LIBRARY_BOOKS = "CLEAR_LIBRARY_BOOKS";

// device info 
export const REQUEST_DEVICE_INFO = "REQUEST_DEVICE_INFO";
export const RECEIVED_DEVICE_INFO = "RECEIVED_DEVICE_INFO";
export const ERROR_DEVICE_INFO = "ERROR_DEVICE_INFO";
export const CLEAR_DEVICE_INFO = "CLEAR_DEVICE_INFO";
// library pdf view

// export const REQUEST_PDF_VIEW = "REQUEST_PDF_VIEW ";
// export const RECEIVED_PDF_VIEW = "RECEIVED_PDF_VIEW " ;
// export const ERROR_PDF_VIEW = "ERROR_PDF_VIEW";
// export const CLEAR_PDF_VIEW = "CLEAR_PDF_VIEW";

//get my test
export const REQUEST_MY_TEST_INFO = "REQUEST_MY_TEST_INFO ";
export const RECEIVED_MY_TEST_INFO = "RECEIVED_MY_TEST_INFO ";
export const ERROR_MY_TEST_INFO = "ERROR_MY_TEST_INFO";
export const CLEAR_MY_TEST_INFO = "CLEAR_MY_TEST_INFO";
export const CLEAR_MY_TEST_INFO_ALL_TESTS = "CLEAR_MY_TEST_INFO_ALL_TESTS";

//check ifsc 
export const REQUEST_IS_VALID_IFSC = 'REQUEST_IS_VALID_IFSC';
export const RECEIVED_IS_VALID_IFSC = 'RECEIVED_IS_VALID_IFSC';
export const ERROR_IS_VALID_IFSC = 'ERROR_IS_VALID_IFSC';
export const CLEAR_IS_VALID_IFSC = 'CLEAR_IS_VALID_IFSC';

// lost phone
export const REQUEST_LOST_PHONE = "REQUEST_LOST_PHONE";
export const RECEIVED_LOST_PHONE = "RECEIVED_LOST_PHONE";
export const ERROR_LOST_PHONE = "ERROR_LOST_PHONE";
export const CLEAR_LOST_PHONE = "CLEAR_LOST_PHONE";

// get all tests
export const REQUEST_GET_ALL_TESTS = "REQUEST_GET_ALL_TESTS";
export const RECEIVED_GET_ALL_TESTS = "RECEIVED_GET_ALL_TESTS";
export const ERROR_GET_ALL_TESTS = "ERROR_GET_ALL_TESTS";
export const CLEAR_GET_ALL_TESTS = "CLEAR_GET_ALL_TESTS";

//add event
export const REQUEST_ADD_EVENT = "REQUEST_ADD_EVENT";
export const RECEIVED_ADD_EVENT = "RECEIVED_ADD_EVENT";
export const ERROR_ADD_EVENT = "ERROR_ADD_EVENT";
export const CLEAR_ADD_EVENT = "CLEAR_ADD_EVENT";

//edit event 
export const REQUEST_EDIT_EVENT = "REQUEST_EDIT_EVENT";
export const RECEIVED_EDIT_EVENT = "RECEIVED_EDIT_EVENT";
export const ERROR_EDIT_EVENT = "ERROR_EDIT_EVENT";
export const CLEAR_EDIT_EVENT = "CLEAR_EDIT_EVENT";

//delete event 
export const REQUEST_DELETE_EVENT = "REQUEST_DELETE_EVENT";
export const RECEIVED_DELETE_EVENT = "RECEIVED_DELETE_EVENT";
export const ERROR_DELETE_EVENT = "ERROR_DELETE_EVENT";
export const CLEAR_DELETE_EVENT = "CLEAR_DELETE_EVENT";

//get event 
export const REQUEST_GET_EVENT = "REQUEST_GET_EVENT";
export const RECEIVED_GET_EVENT = "RECEIVED_GET_EVENT";
export const ERROR_GET_EVENT = "ERROR_GET_EVENT";
export const CLEAR_GET_EVENT = "CLEAR_GET_EVENT";

//get planner month details
export const REQUEST_PLANNER_MONTH_DETAILS = "REQUEST_PLANNER_MONTH_DETAILS";
export const RECEIVED_PLANNER_MONTH_DETAILS = "RECEIVED_PLANNER_MONTH_DETAILS";
export const ERROR_PLANNER_MONTH_DETAILS = "ERROR_PLANNER_MONTH_DETAILS";
export const CLEAR_PLANNER_MONTH_DETAILS = "CLEAR_PLANNER_MONTH_DETAILS";

//get planner day details
export const REQUEST_PLANNER_DAY_DETAILS = "REQUEST_PLANNER_DAY_DETAILS";
export const RECEIVED_PLANNER_DAY_DETAILS = "RECEIVED_PLANNER_DAY_DETAILS";
export const ERROR_PLANNER_DAY_DETAILS = "ERROR_PLANNER_DAY_DETAILS";
export const CLEAR_PLANNER_DAY_DETAILS = "CLEAR_PLANNER_DAY_DETAILS";

//start planned test
export const REQUEST_START_PLANNED_TEST = "REQUEST_START_PLANNED_TEST";
export const RECEIVED_START_PLANNED_TEST = "RECEIVED_START_PLANNED_TEST";
export const ERROR_START_PLANNED_TEST = "ERROR_START_PLANNED_TEST";
export const CLEAR_START_PLANNED_TEST = "CLEAR_START_PLANNED_TEST";

//submit planned test
export const REQUEST_SUBMIT_PLANNED_TEST = "REQUEST_SUBMIT_PLANNED_TEST";
export const RECEIVED_SUBMIT_PLANNED_TEST = "RECEIVED_SUBMIT_PLANNED_TEST";
export const ERROR_SUBMIT_PLANNED_TEST = "ERROR_SUBMIT_PLANNED_TEST";
export const CLEAR_SUBMIT_PLANNED_TEST = "CLEAR_SUBMIT_PLANNED_TEST";

//all subject performance data

export const REQUEST_PLANNED_ALL_SUBJECTS_PERFORMANCE = "REQUEST_PLANNED_ALL_SUBJECTS_PERFORMANCE";
export const RECEIVED_PLANNED_ALL_SUBJECTS_PERFORMANCE = "RECEIVED_PLANNED_ALL_SUBJECTS_PERFORMANCE";
export const ERROR_PLANNED_ALL_SUBJECTS_PERFORMANCE = "ERROR_PLANNED_ALL_SUBJECTS_PERFORMANCE";
export const CLEAR_PLANNED_ALL_SUBJECTS_PERFORMANCE = "CLEAR_PLANNED_ALL_SUBJECTS_PERFORMANCE";

//Planned subject performance 
export const REQUEST_PLANNED_SUBJECT_PERFORMANCE = "REQUEST_PLANNED_SUBJECT_PERFORMANCE";
export const RECEIVED_PLANNED_SUBJECT_PERFORMANCE = "RECEIVED_PLANNED_SUBJECT_PERFORMANCE";
export const ERROR_PLANNED_SUBJECT_PERFORMANCE = "ERROR_PLANNED_SUBJECT_PERFORMANCE";
export const CLEAR_PLANNED_SUBJECT_PERFORMANCE = "CLEAR_PLANNED_SUBJECT_PERFORMANCE";

//Planned topic performance
export const REQUEST_PLANNED_TOPIC_PERFORMANCE = "REQUEST_PLANNED_TOPIC_PERFORMANCE";
export const RECEIVED_PLANNED_TOPIC_PERFORMANCE = "RECEIVED_PLANNED_TOPIC_PERFORMANCE";
export const ERROR_PLANNED_TOPIC_PERFORMANCE = "ERROR_PLANNED_TOPIC_PERFORMANCE";
export const CLEAR_PLANNED_TOPIC_PERFORMANCE = "CLEAR_PLANNED_TOPIC_PERFORMANCE";

// test terms and conditions
export const REQUEST_TEST_TERMS_AND_CONDITIONS = "REQUEST_TEST_TERMS_AND_CONDITIONS";
export const RECEIVED_TEST_TERMS_AND_CONDITIONS = "RECEIVED_TEST_TERMS_AND_CONDITIONS";
export const ERROR_TEST_TERMS_AND_CONDITIONS = "ERROR_TEST_TERMS_AND_CONDITIONS";
export const CLEAR_TEST_TERMS_AND_CONDITIONS = "CLEAR_TEST_TERMS_AND_CONDITIONS";

//about us screen
export const REQUEST_ABOUT_US = "REQUEST_ABOUT_US";
export const RECEIVED_ABOUT_US = "RECEIVED_ABOUT_US";
export const ERROR_ABOUT_US = "ERROR_ABOUT_US";
export const CLEAR_ABOUT_US = "ERROR_ABOUT_US";

// disclaimer screen
export const REQUEST_DISCLAIMER = "REQUEST_DISCLAIMER";
export const RECEIVED_DISCLAIMER = "RECEIVED_DISCLAIMER";
export const ERROR_DISCLAIMER = "ERROR_DISCLAIMER";
export const CLEAR_DISCLAIMER = "CLEAR_DISCLAIMER";

// app terms and conditions
export const REQUEST_APP_TERMS_AND_CONDITIONS = "REQUEST_APP_TERMS_AND_CONDITIONS";
export const RECEIVED_APP_TERMS_AND_CONDITIONS = "RECEIVED_APP_TERMS_AND_CONDITIONS";
export const ERROR_APP_TERMS_AND_CONDITIONS = "ERROR_APP_TERMS_AND_CONDITIONS";
export const CLEAR_APP_TERMS_AND_CONDITIONS = "CLEAR_APP_TERMS_AND_CONDITIONS";

// edit exam preferences
export const REQUEST_EDIT_EXAM_PREFERENCES = "REQUEST_EDIT_EXAM_PREFERENCES";
export const RECEIVED_EDIT_EXAM_PREFERENCES = "RECEIVED_EDIT_EXAM_PREFERENCES";
export const ERROR_EDIT_EXAM_PREFERENCES = "ERROR_EDIT_EXAM_PREFERENCES";
export const CLEAR_EDIT_EXAM_PREFERENCES = "ERROR_EDIT_EXAM_PREFERENCES";


//get topics 
export const REQUEST_TOPICS_BY_SUBJECT = "REQUEST_TOPICS_BY_SUBJECT";
export const RECEIVED_TOPICS_BY_SUBJECT = "RECEIVED_TOPICS_BY_SUBJECT";
export const ERROR_TOPICS_BY_SUBJECT = "ERROR_TOPICS_BY_SUBJECT";
export const CLEAR_TOPICS_BY_SUBJECT = "CLEAR_TOPICS_BY_SUBJECT";

// privacy and policy
export const REQUEST_PRIVACY_POLICY = "REQUEST_PRIVACY_POLICY";
export const RECEIVED_PRIVACY_POLICY = "RECEIVED_PRIVACY_POLICY";
export const ERROR_PRIVACY_POLICY = "ERROR_PRIVACY_POLICY ";
export const CLEAR_PRIVACY_POLICY = "CLEAR_PRIVACY_POLICY";

// bank ac info

export const REQUEST_BANK_INFO = "REQUEST_BANK_INFO";
export const RECEIVED_BANK_INFO = "RECEIVED_BANK_INFO";
export const ERROR_BANK_INFO = "ERROR_BANK_INFO";
export const CLEAR_BANK_INFO = "CLEAR_BANK_INFO";


// delete bank

export const REQUEST_DELETE_BANK_INFO = "REQUEST_DELETE_BANK_INFO";
export const RECEIVED_DELETE_BANK_INFO = "RECEIVED_DELETE_BANK_INFO";
export const ERROR_DELETE_BANK_INFO = "ERROR_DELETE_BANK_INFO";
export const CLEAR_DELETE_BANK_INFO = "CLEAR_DELETE_BANK_INFO";

// username validation

export const REQUEST_USER_NAME_VERIFY = "REQUEST_USER_NAME_VERIFY";
export const RECEIVED_USER_NAME_VERIFY = "RECEIVED_USER_NAME_VERIFY";
export const ERROR_USER_NAME_VERIFY = "ERROR_USER_NAME_VERIFY";
export const CLEAR_USER_NAME_VERIFY = "CLEAR_USER_NAME_FORMAT ";

//change active account
export const REQUEST_CHANGE_ACTIVE_ACCOUNT = 'REQUEST_CHANGE_ACTIVE_ACCOUNT';
export const RECEIVED_CHANGE_ACTIVE_ACCOUNT = 'RECEIVED_CHANGE_ACTIVE_ACCOUNT';
export const ERROR_CHANGE_ACTIVE_ACCOUNT = 'ERROR_CHANGE_ACTIVE_ACCOUNT';
export const CLEAR_CHANGE_ACTIVE_ACCOUNT = 'CLEAR_CHANGE_ACTIVE_ACCOUNT';

// user profile
export const REQUEST_GET_UPDATE_PROFILE = "REQUEST_GET_UPDATE_PROFILE";
export const RECEIVED_GET_UPDATE_PROFILE = "RECEIVED_GET_UPDATE_PROFILE ";
export const ERROR_GET_UPDATE_PROFILE = "ERROR_GET_UPDATE_PROFILE";
export const CLEAR_GET_UPDATE_PROFILE = "CLEAR_GET_UPDATE_PROFILE ";

// question report
export const REQUEST_QUESTION_REPORT = "REQUEST_QUESTION_REPORT ";
export const RECEIVED_QUESTION_REPORT = "RECEIVED_QUESTION_REPORT";
export const ERROR_QUESTION_REPORT = "ERROR_QUESTION_REPORT ";
export const CLEAR_QUESTION_REPORT = "CLEAR_QUESTION_REPORT ";

//get library content
export const REQUEST_LIBRARY_CONTENT = "REQUEST_LIBRARY_CONTENT ";
export const RECEIVED_LIBRARY_CONTENT = "RECEIVED_LIBRARY_CONTENT";
export const ERROR_LIBRARY_CONTENT = "ERROR_LIBRARY_CONTENT ";
export const CLEAR_LIBRARY_CONTENT = "CLEAR_LIBRARY_CONTENT ";

// planner content
export const REQUEST_PLANNER_CONTENT = "REQUEST_PLANNER_CONTENT";
export const RECEIVED_PLANNER_CONTENT = "RECEIVED_PLANNER_CONTENT";
export const ERROR_PLANNER_CONTENT = "ERROR_PLANNER_CONTENT";
export const CLEAR_PLANNER_CONTENT = "CLEAR_PLANNER_CONTENT";

//upload profile
export const REQUEST_UPLOAD_PROFILE = "REQUEST_UPLOAD_PROFILE";
export const RECEIVED_UPLOAD_PROFILE = "RECEIVED_UPLOAD_PROFILE";
export const ERROR_UPLOAD_PROFILE = "ERROR_UPLOAD_PROFILE";
export const CLEAR_UPLOAD_PROFILE = "CLEAR_UPLOAD_PROFILE";

//check user fund ac status
export const REQUEST_CHECK_USER_FUND_AC_STATUS = "REQUEST_CHECK_USER_FUND_AC_STATUS";
export const RECEIVED_CHECK_USER_FUND_AC_STATUS = "RECEIVED_CHECK_USER_FUND_AC_STATUS";
export const ERROR_CHECK_USER_FUND_AC_STATUS = "ERROR_CHECK_USER_FUND_AC_STATUS";
export const CLEAR_CHECK_USER_FUND_AC_STATUS = "CLEAR_CHECK_USER_FUND_AC_STATUS";

//get all subscribe plans
export const REQUEST_ALL_SUBSCRIPTION_PLANS = "REQUEST_ALL_SUBSCRIPTION_PLANS";
export const RECEIVED_ALL_SUBSCRIPTION_PLANS = "RECEIVED_ALL_SUBSCRIPTION_PLANS";
export const ERROR_ALL_SUBSCRIPTION_PLANS = "ERROR_ALL_SUBSCRIPTION_PLANS";
export const CLEAR_ALL_SUBSCRIPTION_PLANS = "CLEAR_ALL_SUBSCRIPTION_PLANS";

//purchase subscription plan
export const PAYMENT_FOR_SUBSCRIPTION_PLAN = "PAYMENT_FOR_SUBSCRIPTION_PLAN";
export const RECEIVED_PAYMENT_FOR_SUBSCRIPTION_PLAN = "RECEIVED_PAYMENT_FOR_SUBSCRIPTION_PLAN";
export const ERROR_PAYMENT_FOR_SUBSCRIPTION_PLAN = "ERROR_PAYMENT_FOR_SUBSCRIPTION_PLAN";
export const CLEAR_PAYMENT_FOR_SUBSCRIPTION_PLAN = "CLEAR_PAYMENT_FOR_SUBSCRIPTION_PLAN";

//send payment ref for subscription plan
export const SEND_PAYMENT_REF_FOR_SUBSCRIPTION_PLAN = "SEND_PAYMENT_REF_FOR_SUBSCRIPTION_PLAN";
export const RECEIVED_SEND_PAYMENT_REF_FOR_SUBSCRIPTION_PLAN = "RECEIVED_SEND_PAYMENT_REF_FOR_SUBSCRIPTION_PLAN";
export const ERROR_SEND_PAYMENT_REF_FOR_SUBSCRIPTION_PLAN = "ERROR_SEND_PAYMENT_REF_FOR_SUBSCRIPTION_PLAN";
export const CLEAR_SEND_PAYMENT_REF_FOR_SUBSCRIPTION_PLAN = "CLEAR_SEND_PAYMENT_REF_FOR_SUBSCRIPTION_PLAN";

//checking 
export const FOR_CHALLENGE_TEST = 'FOR_CHALLENGE_TEST';
export const FOR_SUBSCRIPTION_PLAN = 'FOR_SUBSCRIPTION_PLAN';
export const FOR_LIBRARY_CONTENT = 'FOR_LIBRARY_CONTENT';
export const FOR_TEST_SERIES = 'FOR_TEST_SERIES';
export const FOR_COURSE = 'FOR_COURSE';


//get subscription status params
export const NUMBER_OF_EXAMS = 'number_of_exams';
export const PRACTICE_TESTS_PER_DAY = 'practice_tests_per_day';
export const ACCESS_TO_PLANNER = 'access_to_planner'
export const PLANNED_EVENT_PER_DAY ='planned_events_per_day'
export const PLANNED_TESTS_PER_DAY ='planned_tests_per_day'
export const ADMIN_TESTS_PER_DAY ='access_to_admin_challenges'
export const USER_TESTS_PER_DAY ='access_to_user_challenges'
export const ACCESS_TO_PERFORMANCE ='access_to_performance'
export const ACCESS_TO_LIBRARY = 'access_to_library'
export const ACCESS_TO_LEADERBOARD = 'access_to_leaderboard'
export const ACCESS_TO_FORUM ='access_to_forum'
export const DISPLAY_ADS = 'display_ads'
export const SUPPORT = 'support'
export const ALL ='all'

//get user all active plans
export const REQUEST_GET_USER_ALL_ACTIVE_SUBSCRIPTION_PLANS = "REQUEST_GET_USER_ALL_ACTIVE_SUBSCRIPTION_PLANS";
export const RECEIVED_GET_USER_ALL_ACTIVE_SUBSCRIPTION_PLANS = "RECEIVED_GET_USER_ALL_ACTIVE_SUBSCRIPTION_PLANS";
export const ERROR_GET_USER_ALL_ACTIVE_SUBSCRIPTION_PLANS = "ERROR_GET_USER_ALL_ACTIVE_SUBSCRIPTION_PLANS";
export const CLEAR_GET_USER_ALL_ACTIVE_SUBSCRIPTION_PLANS = "CLEAR_GET_USER_ALL_ACTIVE_SUBSCRIPTION_PLANS";

//get user single plans
export const REQUEST_GET_SINGLE_SUBSCRIPTION_PLAN_INFO = "REQUEST_GET_SINGLE_SUBSCRIPTION_PLAN_INFO";
export const RECEIVED_GET_SINGLE_SUBSCRIPTION_PLAN_INFO = "RECEIVED_GET_SINGLE_SUBSCRIPTION_PLAN_INFO";
export const ERROR_GET_SINGLE_SUBSCRIPTION_PLAN_INFO = "ERROR_GET_SINGLE_SUBSCRIPTION_PLAN_INFO";
export const CLEAR_GET_SINGLE_SUBSCRIPTION_PLAN_INFO = "CLEAR_GET_SINGLE_SUBSCRIPTION_PLAN_INFO";

//subscription status
export const REQUEST_SUBSCRIPTION_STATUS = "REQUEST_SUBSCRIPTION_STATUS";
export const RECEIVED_SUBSCRIPTION_STATUS = "RECEIVED_SUBSCRIPTION_STATUS";
export const ERROR_SUBSCRIPTION_STATUS = "ERROR_SUBSCRIPTION_STATUS";
export const CLEAR_SUBSCRIPTION_STATUS = "CLEAR_SUBSCRIPTION_STATUS";


//async storage constants
export const SUBSCRIPTION_STATUS_INFO = 'SUBSCRIPTION_STATUS_INFO';

//get subscription status from local
export const GET_SUBSCRIPTION_STATUS_FROM_LOCAL = 'GET_SUBSCRIPTION_STATUS_FROM_LOCAL';
export const CLEAR_SUBSCRIPTION_STATUS_FROM_LOCAL = 'CLEAR_SUBSCRIPTION_STATUS_FROM_LOCAL';
export const ERROR_SUBSCRIPTION_STATUS_FROM_LOCAL = 'ERROR_SUBSCRIPTION_STATUS_FROM_LOCAL';

//get library subjects
export const REQUEST_LIBRARY_SUBJECTS = "REQUEST_LIBRARY_SUBJECTS";
export const RECEIVED_LIBRARY_SUBJECTS = "RECEIVED_LIBRARY_SUBJECTS";
export const ERROR_LIBRARY_SUBJECTS = "ERROR_LIBRARY_SUBJECTS";
export const CLEAR_LIBRARY_SUBJECTS = "CLEAR_LIBRARY_SUBJECTS";

//get library topics by subject id
export const REQUEST_LIBRARY_TOPICS_BY_SUBJECT_ID = "REQUEST_LIBRARY_TOPICS_BY_SUBJECT_ID";
export const RECEIVED_LIBRARY_TOPICS_BY_SUBJECT_ID = "RECEIVED_LIBRARY_TOPICS_BY_SUBJECT_ID";
export const ERROR_LIBRARY_TOPICS_BY_SUBJECT_ID = "ERROR_LIBRARY_TOPICS_BY_SUBJECT_ID";
export const CLEAR_LIBRARY_TOPICS_BY_SUBJECT_ID = "CLEAR_LIBRARY_TOPICS_BY_SUBJECT_ID";

//testSeriesList 
export const REQUEST_TEST_SERIES_LIST = "REQUEST_TEST_SERIES_LIST";
export const RECEIVED_TEST_SERIES_LIST = "RECEIVED_TEST_SERIES_LIST";
export const ERROR_TEST_SERIES_LIST = "ERROR_TEST_SERIES_LIST";
export const CLEAR_TEST_SERIES_LIST = "CLEAR_TEST_SERIES_LIST";

//test series test list
export const REQUEST_TEST_SERIES_TEST_LIST = "REQUEST_TEST_SERIES_TEST_LIST";
export const RECEIVED_TEST_SERIES_TEST_LIST = "RECEIVED_TEST_SERIES_TEST_LIST";
export const ERROR_TEST_SERIES_TEST_LIST = "ERROR_TEST_SERIES_TEST_LIST";
export const CLEAR_TEST_SERIES_TEST_LIST = "CLEAR_TEST_SERIES_TEST_LIST";

//check subscription plan validity
export const REQUEST_CHECK_SUBSCRIPTION_PLAN_PRICE_AND_VALIDITY = "REQUEST_CHECK_SUBSCRIPTION_PLAN_PRICE_AND_VALIDITY";
export const RECEIVED_CHECK_SUBSCRIPTION_PLAN_PRICE_AND_VALIDITY = "RECEIVED_CHECK_SUBSCRIPTION_PLAN_PRICE_AND_VALIDITY";
export const ERROR_CHECK_SUBSCRIPTION_PLAN_PRICE_AND_VALIDITY = "ERROR_CHECK_SUBSCRIPTION_PLAN_PRICE_AND_VALIDITY";
export const CLEAR_CHECK_SUBSCRIPTION_PLAN_PRICE_AND_VALIDITY = "CLEAR_CHECK_SUBSCRIPTION_PLAN_PRICE_AND_VALIDITY";

//navigation 
export const NAVIGATION_NAVIGATE= "Navigation/NAVIGATE";
export const NAVIGATION_COMPLETE_TRANSITION = "Navigation/COMPLETE_TRANSITION";
export const SET_NAVIGATION_ANALYTICS = "SET_NAVIGATION_ANALYTICS";
export const CLEAR_NAVIGATION_ANALYTICS_FROM_LOCAL = "CLEAR_NAVIGATION_ANALYTICS_FROM_LOCAL";

//send navigation analytics 
export const REQUEST_SEND_NAVIGATION_LOGS = "REQUEST_SEND_NAVIGATION_LOGS";
export const RECEIVED_SEND_NAVIGATION_LOGS = "RECEIVED_SEND_NAVIGATION_LOGS";
export const ERROR_SEND_NAVIGATION_LOGS = "ERROR_SEND_NAVIGATION_LOGS";
export const CLEAR_SEND_NAVIGATION_LOGS = "CLEAR_SEND_NAVIGATION_LOGS";

//ad clicked
export const AD_CLICKED = 'AD_CLICKED';

//get courses
export const REQUEST_COURSES = "REQUEST_COURSES";
export const RECEIVED_COURSES = "RECEIVED_COURSES";
export const ERROR_COURSES = "ERROR_COURSES";
export const CLEAR_COURSES = "CLEAR_COURSES";

//get lesson planner
export const REQUEST_LESSON_PLANNER = "REQUEST_LESSON_PLANNER";
export const RECEIVED_LESSON_PLANNER = "RECEIVED_LESSON_PLANNER";
export const ERROR_LESSON_PLANNER = "ERROR_LESSON_PLANNER";
export const CLEAR_LESSON_PLANNER = "CLEAR_LESSON_PLANNER";

//get course materials
export const REQUEST_COURSE_MATERIAL = "REQUEST_COURSE_MATERIAL";
export const RECEIVED_COURSE_MATERIAL = "RECEIVED_COURSE_MATERIAL";
export const ERROR_COURSE_MATERIAL = "ERROR_COURSE_MATERIAL";
export const CLEAR_COURSE_MATERIAL = "CLEAR_COURSE_MATERIAL";


//Leader board
export const REQUEST_LEADER_BOARD_DETAILS = "REQUEST_LEADER_BOARD_DETAILS";
export const RECEIVED_LEADER_BOARD_DETAILS = "RECEIVED_LEADER_BOARD_DETAILS";
export const ERROR_LEADER_BOARD_DETAILS = "ERROR_LEADER_BOARD_DETAILS";
export const CLEAR_LEADER_BOARD_DETAILS = "CLEAR_LEADER_BOARD_DETAILS";

//transactions

export const REQUEST_USER_PAYMENTS_DETAILS = "REQUEST_USER_PAYMENTS_DETAILS";
export const RECEIVED_USER_PAYMENTS_DETAILS = "RECEIVED_USER_PAYMENTS_DETAILS";
export const ERROR_USER_PAYMENTS_DETAILS = "ERROR_USER_PAYMENTS_DETAILS";
export const CLEAR_USER_PAYMENTS_DETAILS = "CLEAR_USER_PAYMENTS_DETAILS";

//htmlContent
export const REQUEST_GET_HTML_CONTENT = "REQUEST_GET_HTML_CONTENT";
export const RECEIVED_GET_HTML_CONTENT = "RECEIVED_GET_HTML_CONTENT";
export const ERROR_GET_HTML_CONTENT = "ERROR_GET_HTML_CONTENT";
export const CLEAR_GET_HTML_CONTENT = "CLEAR_GET_HTML_CONTENT";

//Add details
export const REQUEST_AD_LOCATION = "REQUEST_AD_LOCATION";
export const RECEIVED_AD_LOCATION = "RECEIVED_AD_LOCATION";
export const ERROR_AD_LOCATION = "ERROR_AD_LOCATION";
export const CLEAR_AD_LOCATION = "CLEAR_AD_LOCATION";

//locationStore
export const REQUEST_SEND_USER_LOCATION_STORE = "REQUEST_SEND_USER_LOCATION_STORE";
export const RECEIVED_SEND_USER_LOCATION_STORE = "RECEIVED_SEND_USER_LOCATION_STORE";
export const ERROR_SEND_USER_LOCATION_STORE = "ERROR_SEND_USER_LOCATION_STORE";
export const CLEAR_SEND_USER_LOCATION_STORE = "CLEAR_SEND_USER_LOCATION_STORE";

//currentAffairs pagination
export const REQUEST_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION = "REQUEST_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION";
export const RECEIVED_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION = "RECEIVED_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION";
export const ERROR_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION = "ERROR_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION";
export const CLEAR_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION = "CLEAR_GET_LIST_OF_CURRENT_AFFAIRS_FOR_PAGINATION";


//performanceExams screen

export const REQUEST_FOR_GET_PERFORMANCE_EXAM_PREFERENCES = "REQUEST_FOR_GET_PERFORMANCE_EXAM_PREFERENCES";
export const RECEIVED_FOR_GET_PERFORMANCE_EXAM_PREFERENCES = "RECEIVED_FOR_GET_PERFORMANCE_EXAM_PREFERENCES";
export const ERROR_FOR_GET_PERFORMANCE_EXAM_PREFERENCES = "ERROR_FOR_GET_PERFORMANCE_EXAM_PREFERENCES";
export const CLEAR_FOR_GET_PERFORMANCE_EXAM_PREFERENCES = "CLEAR_FOR_GET_PERFORMANCE_EXAM_PREFERENCES";

//get app version
export const REQUEST_APP_VERSION = "REQUEST_APP_VERSION";
export const RECEIVED_APP_VERSION = "RECEIVED_APP_VERSION";
export const ERROR_APP_VERSION = "ERROR_APP_VERSION";
export const CLEAR_APP_VERSION = "CLEAR_APP_VERSION";

//leaderboardForChalleng
export const REQUEST_LEADER_BOARD_DETAILS_FOR_ADMIN_CHALLENGE_TEST = "REQUEST_LEADER_BOARD_DETAILS_FOR_ADMIN_CHALLENGE_TEST";
export const RECEIVED_LEADER_BOARD_DETAILS_FOR_ADMIN_CHALLENGE_TEST = "RECEIVED_LEADER_BOARD_DETAILS_FOR_ADMIN_CHALLENGE_TEST";
export const ERROR_LEADER_BOARD_DETAILS_FOR_ADMIN_CHALLENGE_TEST = "ERROR_LEADER_BOARD_DETAILS_FOR_ADMIN_CHALLENGE_TEST";
export const CLEAR_LEADER_BOARD_DETAILS_FOR_ADMIN_CHALLENGE_TEST = "CLEAR_LEADER_BOARD_DETAILS_FOR_ADMIN_CHALLENGE_TEST";


export const REQUEST_GET_COINS = "REQUEST_GET_COINS";
export const RECEIVED_GET_COINS = "RECEIVED_GET_COINS";
export const ERROR_GET_COINS = "ERROR_GET_COINS";
export const CLEAR_GET_COINS = "CLEAR_GET_COINS";


export const REQUEST_GET_SCANNED_QUESTIONS = "REQUEST_GET_SCANNED_QUESTIONS";
export const RECEIVED_GET_SCANNED_QUESTIONS = "RECEIVED_GET_SCANNED_QUESTIONS";
export const ERROR_GET_SCANNED_QUESTIONS = "ERROR_GET_SCANNED_QUESTIONS";
export const CLEAR_GET_SCANNED_QUESTIONS = "CLEAR_GET_SCANNED_QUESTIONS";


export const REQUEST_UPDATED_SCANNED_RESULTS = "REQUEST_UPDATED_SCANNED_RESULTS";
export const RECEIVED_UPDATED_SCANNED_RESULTS = "RECEIVED_UPDATED_SCANNED_RESULTS";
export const ERROR_UPDATED_SCANNED_RESULTS = "ERROR_UPDATED_SCANNED_RESULTS";
export const CLEAR_UPDATED_SCANNED_RESULTS = "CLEAR_UPDATED_SCANNED_RESULTS";


export const REQUEST_GET_SOURCE_FILES_WITH_JW_MEDIA_ID = "REQUEST_GET_SOURCE_FILES_WITH_JW_MEDIA_ID";
export const RECEIVED_GET_SOURCE_FILES_WITH_JW_MEDIA_ID = "RECEIVED_GET_SOURCE_FILES_WITH_JW_MEDIA_ID";
export const ERROR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID = "ERROR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID";
export const CLEAR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID = "CLEAR_GET_SOURCE_FILES_WITH_JW_MEDIA_ID";